
import { React, useContext } from 'react'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'
import { MenuExportacao } from '../../../../components/MenuExportacao'
import { format, parseISO } from 'date-fns'
import { useRef } from 'react'
import { useState } from 'react'
import { ModalDetalhes } from '../ModalDetalhes'
import { SVGPDF } from '../../../../components/SVG/SVGPDF'
import { api } from '../../../../services/api'
import MyContext from '../../../../contexts/myContext'
import { GravaLogB2B } from '../../../../pages/Login/functions/GravaLogB2B'

export function GridRegistros(props) {
    const handle = useFullScreenHandle()
    const printRef = useRef()
    const [isFullScreen, setIsFullScrenn] = useState(false)
    const [orderBy, setOrderBy] = useState('CodigoPedido')
    const [ascDesc, setAscDesc] = useState(1)
    const [CodigoRegistroSelecionado, setCodigoRegistroSelecionado] = useState([])

    function setFullScreen() {
        if (isFullScreen) {
            handle.exit()
            setIsFullScrenn(false)
        } else {
            handle.enter()
            setIsFullScrenn(true)
        }
    }

    function getValorSomaRegistros() {
        let soma = 0

        props.RegistrosBDFiltro
            .map(item => {
                soma += item.Total
            })

        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(soma)
    }

    const [isDownloadPDF, setIsDownloadPDF] = useState(false)

    const { user } = useContext(MyContext)

    const handleDownloadPDF = async (Registro) => {
        try {
            if (Registro.Boleto === 'SIM') {
                setIsDownloadPDF(true)
                // Enviando os dados JSON para o servidor
                const response = await api.get(`/api/gerarpdf/BOLETO/${Registro.CodigoRegistro}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    responseType: 'blob'
                });

                // Criando um URL temporário para o arquivo
                const url = window.URL.createObjectURL(new Blob([response.data]));

                // Criando um link e clicando nele para iniciar o download
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `BOLETO_${Registro.CodigoRegistro}.pdf`);
                document.body.appendChild(link);
                link.click();
                await GravaLogB2B(`DOWNLOAD PDF - BOLETO_${Registro.CodigoRegistro}.pdf`, user.cnpj);
            }

        } catch (error) {
            console.error('Erro ao baixar o arquivo:', error);
        }
        finally {
            setIsDownloadPDF(false)
        }
    };

    return (
        <FullScreen handle={handle}>
            <div ref={printRef} className='useExport relative'>
                <MenuExportacao
                    filename={'RegistrosGrid'}
                    sheet={'RegistrosGrid'}
                    onlyCSV={true}
                    isFullScreen={isFullScreen}
                    setFullScreen={() => setFullScreen()}
                    idTable="table-to-xls-b2b-pedidos-pdv"
                />
                <div
                    className={`relative mt-1 bg-gray-50 h-full  w-full ${isFullScreen && 'p-4'} shadow-lg`}

                >
                    <h1 className='bg-gradient-to-r rounded-t-md from-slate-900 to-slate-700 text-white-100 font-semibold p-2'>
                        Relação de Títulos Pendentes e Vencidos
                    </h1>
                    <div className="flex flex-col h-full">
                        <div className={`overflow-auto ${isFullScreen ? '!max-h-[87vh]' : '!max-h-[30vh]'} `}>
                            <table id="table-to-xls-b2b-pedidos-pdv" className=" border-separate table-fixed w-full">
                                <thead>
                                    <tr className="text-sm sticky top-0 bg-gradient-to-r from-slate-200 to-slate-100">
                                        <th className="w-[5rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Boleto')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>PDF</th>
                                        <th className="w-[5rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('CodigoRegistro')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>CÓD.</th>
                                        <th className="w-[5rem]  text-center cursor-pointer" onClick={() => {
                                            setOrderBy('CodigoCliente')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>CÓD. DEST.</th>
                                        <th className="w-[15rem]  text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Nome')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>NOME/RAZÃO SOCIAL</th>
                                        <th className="w-[6rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('NCheque')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>TÍTULO</th>
                                        <th className="w-[6rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DescricaoConta')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>BANCO</th>
                                        <th className="w-[6rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DtLancamento')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>LANÇAMENTO</th>
                                        <th className="w-[6rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Vencimento')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>VENCIMENTO</th>
                                        <th className="w-[6rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DtRecebimento')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>RECEBIMENTO</th>
                                        <th className="w-[9rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Total')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>VALOR R$</th>

                                        <th className="w-[9rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Status')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>STATUS</th>
                                        <th className="w-[9rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Situacao')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>SITUAÇÃO</th>
                                        <th className="w-[9rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DiferencaDias')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>DIAS ATRASO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.RegistrosBDFiltro?.length > 0
                                        ? (
                                            props.RegistrosBDFiltro.sort((a, b) =>
                                                a[orderBy] > b[orderBy]
                                                    ? ascDesc === 0
                                                        ? 1
                                                        : -1
                                                    : ascDesc === 0
                                                        ? -1
                                                        : 1
                                            ).map((Registro, key) => {
                                                return (
                                                    <tr key={key} onClick={() => setCodigoRegistroSelecionado(Registro)} className="odd:bg-white-100 even:bg-gray-100">
                                                        <td
                                                            className={` selection:text-sm text-center pr-1 `}
                                                            onClick={() => {
                                                                handleDownloadPDF(Registro)
                                                            }}
                                                        >
                                                            <div className={` ${Registro.Boleto === 'SIM' ? ' ' : 'cursor-not-allowed opacity-30'}  flex items-center justify-center cursor-pointer p-1`}>
                                                                <SVGPDF
                                                                    className={``}
                                                                    color={"red"}
                                                                    height="1.2rem"
                                                                    width="1.2rem"
                                                                />

                                                                {isDownloadPDF ?
                                                                    <div className='ml-4' role="status">
                                                                        <svg aria-hidden="true" class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                                        </svg>
                                                                        <span class="sr-only">Loading...</span>
                                                                    </div>
                                                                    :
                                                                    null
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="text-sm text-center pr-1">{Registro.CodigoRegistro}</td>
                                                        <td className="text-sm text-center pr-1">{Registro.CodigoCliente}</td>
                                                        <td className="text-sm text-left truncate pr-1">{Registro.Nome}</td>
                                                        <td className="text-sm text-left truncate pr-1">{Registro.NCheque}</td>
                                                        <td className="text-sm text-left truncate pr-1">{Registro.DescricaoConta}</td>
                                                        <td className="text-sm truncate text-center">{format(parseISO(Registro.DtLancamento), 'dd/MM/yyyy')}</td>
                                                        <td className="text-sm truncate text-center">{Registro.Vencimento ? format(parseISO(Registro.Vencimento), 'dd/MM/yyyy') : ''}</td>
                                                        <td className="text-sm truncate text-center">{Registro.DtRecebimento ? format(parseISO(Registro.DtRecebimento), 'dd/MM/yyyy') : ''}</td>
                                                        <td className="text-sm text-right">{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(Registro.Total)}</td>
                                                        <td className="text-sm text-center pr-1 truncate">{Registro.Status}</td>
                                                        <td className="text-sm text-center pr-1 truncate">{Registro.Situacao}</td>
                                                        <td className="text-sm text-center pr-1 truncate">{Registro.DiferencaDias}</td>

                                                    </tr>
                                                )
                                            })
                                        )
                                        : (
                                            <tr className="text-center">
                                                <td className="p-3 italic" colSpan={12}>
                                                    Sem registros
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-white-100 flex-row justify-between  p-2 border-t-2 flex align-middle  bg-gradient-to-r from-slate-200 to-slate-100">
                            <p className="text-sm font-bold">
                                Total = {props.RegistrosBDFiltro?.length.toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(',', '.')}
                            </p>
                            <p className="text-sm font-semibold ">
                                Soma = R$ {getValorSomaRegistros()}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </FullScreen>
    )
}
